import Importer from "../../../../../Components/Importer/importer";
import { ImportType } from "../../../../../Core/Api/Types/import-type";

function InventoryBulkMetaImporter() {
  return <Importer context={ImportType.MetadataImport} />;
}

export default InventoryBulkMetaImporter;
